import React, { useEffect, useState } from "react"
import { Space, Button, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useLocation, Redirect } from "react-router-dom";
import { Xpagination, Xtable, XtagTable } from "../../../component/Xcomponent";
import { connect } from "react-redux";
import _ from "lodash"
// action
import { getEmergencyDtrfList, getEmergencyDtrfListResetState } from '../../../action/getEmergencyDtrfListAction'
import { useContext } from "react";
import HeaderContext from "../../../context/HeaderContext";


const EmergencyDtrfDashboard = props => {
    const {
        getEmergencyDtrfList, getEmergencyDtrfListState, getEmergencyDtrfListResetState,
    } = props


    // drawer
    const search = useLocation().search;
    const [redirect, setRedirect] = useState(["", false])

    const page = new URLSearchParams(search).get('page');
    const [searchText, setSearchText] = useState({})
    const [refresh, setRefresh] = useState(0)
    const {setTitle} = useContext(HeaderContext);
    setTitle("Emergency Dashboard ");    

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        setSearchText({
            ...searchText,
            [dataIndex]: selectedKeys[0]
        })
    }

    const handleReset = (clearFilters, dataIndex) => {
        let remainSearch = _.omit(searchText, [dataIndex])
        clearFilters()
        setSearchText(remainSearch)
    }


    const getColumnSearchProps = (dataIndex, name) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    placeholder={`Search ${name}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => [handleSearch(selectedKeys, confirm, dataIndex), setPagination({ ...pagination, ['page']: 1 })]}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => [handleSearch(selectedKeys, confirm, dataIndex), setPagination({ ...pagination, ['page']: 1 })]}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => handleReset(clearFilters, dataIndex)} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    });


    //pagination
    const [pagination, setPagination] = useState({
        page: page ? page : 1,
        records: 25
    })

    const [columns, setColumns] = useState([])
    const [dataSource, setDataSource] = useState([])


    //callback
    useEffect(() => {
        return (() => {
            getEmergencyDtrfListResetState()
        })
    }, [])

    // Callbacks
    useEffect(() => {
        getEmergencyDtrfList({
            page: pagination.page,
            records: pagination.records,
            ...searchText
        });
        setRedirect([true, `/emeregency-dtrf/dashboard?page=${pagination.page}`])
    }, [refresh, pagination, searchText])


    //useeffect and column
    useEffect(() => {
        if (getEmergencyDtrfListState.apiState === "success") {
            setColumns([
                {
                    title: 'Institute',
                    dataIndex: 'institute',
                    width: '20%',
                    ...getColumnSearchProps('institute', 'Institute')
                },
                {
                    title: 'Test',
                    dataIndex: 'tests',
                    width: '20%',
                    render: tests => (
                        <>
                            <Space>
                                <div>
                                    {tests.length > 0 && tests.map(item => (
                                        <XtagTable>{item.display_test_name} </XtagTable>
                                    ))}
                                </div>
                            </Space>
                        </>
                    ),
                    ...getColumnSearchProps('display_test_name', 'Test Name')
                },
                {
                    title: "Patient Name",
                    dataIndex: "patients",
                    width: "25%",
                    render: patient => (
                        <>
                            <Space>
                                <div>
                                    {/* {patients[0].map(item => ( */}
                                        <XtagTable>{patient.firstName} {patient.lastName} - {patient.phone}</XtagTable>
                                    {/* )) */}
                                    {/* } */}
                                    {/* {patients.length > 0 && patients[1].map(item => (
                                        <XtagTable>{item.patient_name} - {item.patient_mobile_number}</XtagTable>
                                    ))
                                    } */}
                                </div>
                            </Space>
                        </>
                    ),
                    ...getColumnSearchProps('name', 'Patient Name')
                },
                // {
                //     title: "Sample ID",
                //     dataIndex: "sample_info",
                //     width: "25%",
                //     render: sample_info =>
                //         <Space>
                //             <div>
                //                 {sample_info.map(sampleInfoItem =>
                //                     sampleInfoItem.sample_info.sampleInfo.map(sampleInfoItem1 =>
                //                         sampleInfoItem1.map(test =>
                //                             test.map(sample =>
                //                                 sample.map(containerItem =>
                //                                     <XtagTable>{containerItem.containerId}</XtagTable>
                //                                 )
                //                             )
                //                         )
                //                     )
                //                 )}
                //             </div>
                //         </Space>,
                //     ...getColumnSearchProps('container_id', 'Sample ID')
                // },
                {
                    title: 'Status',
                    dataIndex: 'status',
                    width: '20%',
                    ...getColumnSearchProps('status', 'Status')
                },

            ])
            let rows = []
            getEmergencyDtrfListState.list.map((item) => {
                rows.push(
                    {
                        key: item._id,
                        tests: item.dtrf.test_info.selectedTests,
                        institute: item.dtrf.institute_info.instituteName.name,
                        patients: item.dtrf.patient_details[0],
                        // sample_info: item.dtrf.sample_info.sampleInfo,
                        status: item.status,
                        // containers: item.containers,
                        doctor_name: item.dtrf.doctor_info? item.dtrf.doctor_info.doctorName.label:"",
                    }
                )
            })
            setDataSource(rows)
        }
    }, [getEmergencyDtrfListState])

    //pagination


    return (
        <>
            {redirect[0] &&
                <Redirect to={redirect[1]} />}
            {getEmergencyDtrfListState.apiState === "error" &&
                <div style={{ height: 500, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }} >
                    <p>{getEmergencyDtrfListState.message}</p>
                    <Button type="primary" onClick={() => setRefresh(refresh + 1)} >TRY AGAIN</Button>
                </div>
            }

            {getEmergencyDtrfListState.apiState !== "error" &&
                <>
                    <Xtable columns={columns} dataSource={dataSource} pagination={false} scroll={{ x: 768 }}
                        loading={getEmergencyDtrfListState.apiState === "loading"}
                    />
                    <Xpagination
                        style={{gap:"5px",flexWrap:"wrap"}}
                        pageSizeOptions={['25', '50', '100', '500']}
                        showSizeChanger
                        total={getEmergencyDtrfListState.pagination.total_records}
                        onChange={(page, pageSize) => setPagination({ page: page, records: pageSize })}
                        current={pagination.page}
                        defaultPageSize={pagination.records}
                        showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                    />
                </>
            }
        </>
    );
};

const mapStateToProps = (state) => ({
    getEmergencyDtrfListState: state.getEmergencyDtrfList,
})

const mapDispatchToProps = (dispatch) => ({
    getEmergencyDtrfList: (params) => dispatch(getEmergencyDtrfList(params)),
    getEmergencyDtrfListResetState: () => dispatch(getEmergencyDtrfListResetState()),
})

export default connect(mapStateToProps, mapDispatchToProps)(EmergencyDtrfDashboard);
